import { request } from 'src/shared/helpers/request';

export const parseImageNameFromUrl = (url: string): string =>
  url.split('/')?.reverse()?.[0]?.split('.').slice(0, -1).join('.') ?? '';

export const contentTypeToExtension = (contentType: string) => {
  switch (contentType) {
    case 'image/avif':
      return 'avif';
    case 'image/bmp':
      return 'bmp';
    case 'image/x-ico':
      return 'ico';
    case 'image/jpeg':
      return 'jpg';
    case 'image/png':
      return 'png';
    case 'image/svg+xml':
      return 'svg';
    case 'image/tiff':
      return 'tif';
    case 'image/webp':
      return 'webp';
    case 'image/x-xbitmap':
      return 'xbm';
    default:
      return '';
  }
};

export const INVALID_EXTENSION_ERROR_MESSAGE = 'Invalid content extension';

export const imageUrlToFile = async (imageUrl: string, fileName?: string) => {
  const response = await request(imageUrl);
  const blob = await response.blob();

  const name = fileName ?? parseImageNameFromUrl(imageUrl) ?? 'image';
  const ext = contentTypeToExtension(blob.type);
  if (!ext) {
    throw new Error(INVALID_EXTENSION_ERROR_MESSAGE);
  }

  return new File([blob], `${name}.${ext}`, {
    type: blob.type,
  });
};
